'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertObjectToArray = convertObjectToArray;
exports.checkMobile = checkMobile;
exports.checkBrowser = checkBrowser;
exports.flattenChildren = flattenChildren;
exports.flattenParent = flattenParent;
exports.flattenNode = flattenNode;
exports.copyTreeState = copyTreeState;
exports.getNodeById = getNodeById;
exports.getRootNode = getRootNode;
exports.debounce = debounce;
exports.throttle = throttle;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function convertObjectToArray(object) {
  var indexName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'index';

  var arr = Object.keys(object).map(function (key) {
    return object[key];
  });
  arr.sort(function (first, second) {
    return second[indexName] - first[indexName];
  });
  return arr;
}

function checkMobile() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  }
  return false;
}

function checkBrowser() {
  var browserName = '';
  // proudly stolen from http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
  // Opera 8.0+
  var isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  if (isOpera) {
    browserName = 'opera';
  }

  // Firefox 1.0+
  var isFirefox = typeof InstallTrigger !== 'undefined';
  if (isFirefox) {
    browserName = 'firefox';
  }

  // At least Safari 3+: "[object HTMLElementConstructor]"
  var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
  if (isSafari) {
    browserName = 'safari';
  }

  // Internet Explorer 6-11
  var isIE = /* @cc_on!@ */false || !!document.documentMode;
  if (isIE) {
    browserName = 'ie';
  }

  // Edge 20+
  var isEdge = !isIE && !!window.StyleMedia;
  if (isEdge) {
    browserName = 'ie';
  }

  // Chrome 1+
  var isChrome = !!window.chrome && !!window.chrome.webstore;
  if (isChrome) {
    browserName = 'chrome';
  }

  return browserName;
}

function flattenChildren(node, checked, expanded, left) {
  var data = _defineProperty({}, node.id, node);
  var arr = [node];

  var _loop = function _loop() {
    var current = arr[0];
    arr.shift();
    if (typeof current.children !== 'undefined' && current.children !== null) {
      Object.keys(current.children).forEach(function (key) {
        data[key] = current.children[key];
        data[key].expanded = typeof expanded !== 'undefined' ? expanded : data[key].expanded;
        data[key].left = typeof left !== 'undefined' ? left : data[key].left;
        data[key].checked = typeof checked !== 'undefined' ? checked : data[key].checked;
        data[key].parent = current;
        arr.push(current.children[key]);
      });
    }
  };

  while (arr.length > 0) {
    _loop();
  }
  return data;
}

function flattenParent(node, checked, expanded, left) {
  var results = {};
  var currNode = node;
  while (currNode.parent && currNode.parent !== null) {
    currNode.expanded = typeof expanded !== 'undefined' ? expanded : currNode.expanded;
    currNode.left = typeof left !== 'undefined' ? left : currNode.left;
    currNode.checked = typeof checked !== 'undefined' ? checked : currNode.checked;
    results = Object.assign(results, currNode);
    currNode = currNode.parent;
  }
  return results;
}

function flattenNode(node, checked) {
  var expanded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var left = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  return Object.assign(flattenParent(node, checked, expanded, left), flattenChildren(node, checked, expanded, left));
}

function copyTreeState(originalNode, copyNode) {
  var flatOriginalNode = flattenNode(originalNode);
  var flatCopyNode = flattenNode(copyNode);

  Object.keys(flatCopyNode).forEach(function (key) {
    if (flatOriginalNode[key] && flatCopyNode[key]) {
      flatOriginalNode[key].checked = flatCopyNode[key].checked;
    }
  });
}

function getNodeById(node, ids) {
  var nodes = flattenNode(node);
  return ids.map(function (id) {
    return nodes[id] ? nodes[id] : null;
  });
}

function getRootNode(node) {
  var rootNode = node;
  while (typeof rootNode.parentId !== 'undefined' && typeof rootNode.parent !== 'undefined' && rootNode.parent !== null) {
    rootNode = rootNode.parent;
  };
  return rootNode;
}

function debounce(func, wait) {
  var timeout = null;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return func.apply(context, args);
    }, wait);
  };
}

function throttle(func, wait) {
  var lastcall = 0;

  return function () {
    var now = new Date().getTime();
    if (now - lastcall < wait) {
      return;
    }
    lastcall = now;
    return func.apply(undefined, arguments);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/utils.js
// module id = 116
// module chunks = 1